import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { IconLoyaltyPoints } from 'components/icons/loyalty-points-icon';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { IBonusPointsProps } from './types';

const BonusPointsContainer = styled.div`
  color: ${Styles.color.loyaltyHighlight};
  font-size: 0.75rem;
  text-transform: uppercase;
  line-height: 1.6;
  font-weight: bold;
`;

const StyledLoyaltyPointsIcon = styled(IconLoyaltyPoints)`
  width: 0.875rem;
  height: 0.875rem;
  vertical-align: text-top;
  margin-inline-end: 0.25rem;
  path {
    fill: ${Styles.color.loyaltyHighlight};
  }
`;

export const BonusPoints: FC<IBonusPointsProps> = ({ bonusPoints, className }) => {
  const { formatMessage } = useIntl();
  const enableBonusPointsRewardsLogo = Boolean(
    useFlag(LaunchDarklyFlag.ENABLE_BONUS_POINTS_REWARDS_LOGO)
  );
  return (
    <BonusPointsContainer className={className} data-testid="promotion-bonus-points">
      {enableBonusPointsRewardsLogo && <StyledLoyaltyPointsIcon />}
      {formatMessage({ id: 'bonusPoints' }, { points: bonusPoints })}
    </BonusPointsContainer>
  );
};
